import { format } from 'date-fns';
import { Button } from '@/components/ui/button';
import type { ArchiveWindow } from '@/hooks/archiveWindow';
import type { DateRange } from '@/types/filters';

export function ArchiveWindowNotice({
  window,
  range,
  onChange,
}: {
  window: ArchiveWindow;
  range: DateRange;
  onChange: (window: 'recent' | 'all') => void;
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2 rounded-lg border border-blue-200 bg-blue-50 px-3 py-2 text-sm leading-snug">
      <div>
        <p className="font-medium">
          {window === 'recent'
            ? `Letzte 8 Wochen · erstellt ab ${range.from ? format(range.from, 'dd.MM.yyyy') : ''}`
            : window === 'all'
              ? 'Gesamtes Archiv · alle Zeiträume'
              : 'Archiv · gewählter Zeitraum'}
        </p>
        <p className="text-gray-600">
          {window === 'recent'
            ? 'Suche und Export sind auf diesen Zeitraum begrenzt. Ältere Einträge können Sie zusätzlich einbeziehen.'
            : 'Die Suche in älteren Einträgen kann länger dauern.'}{' '}
          Die Statuszahlen oben beziehen sich auf das gesamte Archiv.
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        {window !== 'recent' && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => onChange('recent')}
          >
            Letzte 8 Wochen
          </Button>
        )}
        {window !== 'all' && (
          <Button variant="outline" size="sm" onClick={() => onChange('all')}>
            Ältere Einträge einbeziehen (langsam)
          </Button>
        )}
      </div>
    </div>
  );
}
